<template>
  <div class="user-role-card bg-light rounded-3 p-4 card-hover" @click.prevent="$emit('selected', userRole)">
    <div class="left">
<!--      <img class="d-none d-sm-block rounded-circle" :src="getAvatarSrc(userRole)" width="80" :alt="userRole.name">-->
      <user-role-avatar class="d-none d-sm-block rounded-circle"
      :user-role="userRole" width="80"></user-role-avatar>
    </div>
    <div class="middle">
      <b>{{ userRole.name }}</b>
      <p class="mt-1 mb-0 pb-1 small">
        {{ userRole.bio }}
      </p>
    </div>
    <div class="right">
      <span v-if="isUserRoleSelected" class="badge bg-primary">Current</span>
    </div>
  </div>
</template>

<script>
import Images from "../../mixins/Images";
import {mapGetters} from "vuex";
import UserRoleAvatar from "../../components/UserRoleAvatar";

export default {
  name: "UserRoleCard",
  components: {UserRoleAvatar},
  props: ['userRole'],
  mixins: [Images],
  computed: {
   ...mapGetters('auth', {
     currentUserRole: 'userRole'
   }),

    isUserRoleSelected() {
     return this.userRole === this.currentUserRole;
    }
  }
}
</script>

<style scoped lang="scss">
.user-role-card:hover {
  cursor: pointer;
}

.user-role-card {
  display: flex;
  flex-direction: row;

  .left {
    width: 100px;
    min-width: 100px;
    flex-shrink: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .middle {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .right {
    flex-shrink: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
}
</style>